import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  addObj,
  modifyObj,
  deleteObj,
} from '@/api/vehicletypeserv'

export default {
  state: {
    state_VehicleType_GetAllResult: null,
    state_VehicleType_SearchByNameResult: null,
    state_VehicleType_GetPageResult: null,
    state_VehicleType_GetDetailResult: null,
    state_VehicleType_AddObjResult: null,
    state_VehicleType_ModifyObjResult: null,
    state_VehicleType_DeleteObjResult: null,
  },
  mutations: {
    SET_VEHICLETYPE_GETALL_RESULT: (state, rst) => {
      state.state_VehicleType_GetAllResult = rst;
    },
    SET_VEHICLETYPE_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_VehicleType_SearchByNameResult = rst;
    },
    SET_VEHICLETYPE_GETPAGE_RESULT: (state, rst) => {
      state.state_VehicleType_GetPageResult = rst;
    },
    SET_VEHICLETYPE_GETDETAIL_RESULT: (state, rst) => {
      state.state_VehicleType_GetDetailResult = rst;
    },
    SET_VEHICLETYPE_ADDOBJ_RESULT: (state, rst) => {
      state.state_VehicleType_AddObjResult = rst;
    },
    SET_VEHICLETYPE_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_VehicleType_ModifyObjResult = rst;
    },
    SET_VEHICLETYPE_DELETEOBJ_RESULT: (state, rst) => {
      state.state_VehicleType_DeleteObjResult = rst;
    },
  },
  actions: {
    VehicleTypeServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLETYPE_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLETYPE_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleTypeServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLETYPE_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLETYPE_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleTypeServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLETYPE_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLETYPE_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleTypeServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLETYPE_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLETYPE_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleTypeServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLETYPE_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLETYPE_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleTypeServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLETYPE_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLETYPE_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleTypeServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLETYPE_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLETYPE_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_VehicleType_GetAllResult: state => {
      return state.state_VehicleType_GetAllResult;
    },
    get_VehicleType_SearchByNameResult: state => {
      return state.state_VehicleType_SearchByNameResult;
    },
    get_VehicleType_GetPageResult: state => {
      return state.state_VehicleType_GetPageResult;
    },
    get_VehicleType_GetDetailResult: state => {
      return state.state_VehicleType_GetDetailResult;
    },
    get_VehicleType_AddObjResult: state => {
      return state.state_VehicleType_AddObjResult;
    },
    get_VehicleType_ModifyObjResult: state => {
      return state.state_VehicleType_ModifyObjResult;
    },
    get_VehicleType_DeleteObjResult: state => {
      return state.state_VehicleType_DeleteObjResult;
    },
  }
}